'use strict';

/*
 * Sets focus programatically to an element on the page
 */

angular.module('v6CoreModule').directive('setFocus', ($timeout) => ({
  restrict: 'A',

  link: function (scope, elm, attrs) {
    //Set focus programatically to a field
    scope.$root.$on('setFocus', (listener, name) => {
      let highlight = false,
        t;

      if (name instanceof Array) {
        highlight = name[1];
        name = name[0];
      }
      if (elm.attr('id') == name) {
        if (highlight) {
          t = $timeout(() => {
            let text = '';
            $(elm).focus();
            $(elm).select();
            const attr = elm.attr('ng-model');
            if (window.getSelection) {
              text = window.getSelection().toString();
            } else if (
              document.selection &&
              document.selection.type != 'Control'
            ) {
              text = document.selection.createRange().text;
            }
            scope.$root.textProperties[attr] = text;
            clearTimeout(t);
          }, 250);
        } else {
          t = $timeout(() => {
            $(elm).focus();
            clearTimeout(t);
          }, 400);
        }
      }
    });
  },
}));
